<template>
  <div class="locale-changer">
    <SfSelect
      v-model="$i18n.locale"
      class="sf-select--underlined"
    >
      <SfSelectOption
        v-for="language in languages"
        :key="language.Id"
        :value="language.LanguageCulture"
        :placeholder="$t('Select option')"
      >
        {{ language.Name }}
      </SfSelectOption>
    </SfSelect>
  </div>
</template>

<script>
import { SfSelect } from '@storefront-ui/vue';
import config from '../mixins/config';

export default {
  name: 'LocaleChanger',
  mixins: [config],
  components: {
    SfSelect,
  },
};
</script>
